import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentViewport = ({
  wrapperClassName,
  paddingClassName,
  wrapperStyle,
  children
}) => /*#__PURE__*/_jsx("div", {
  className: classNames(paddingClassName, 'content-viewport__responsive-padding'),
  children: /*#__PURE__*/_jsx("div", {
    className: classNames(wrapperClassName, 'content-viewport__responsive-wrapper'),
    style: wrapperStyle,
    children: children
  })
});
export default ContentViewport;